export default __webpack_public_path__ + "static/media/battoa.ef4d845b.png";